import { useEffect, useState } from "react";
import ApiEventos from "../services/eventoService";
import ApiAcademia from "../services/academiaService";

export default function useEventoInscricao(user, evento, token) {

    const [vinculo, setVinculo] = useState(null);
    const [valor, setValor] = useState(0);
    const [desconto, setDesconto] = useState(0);
    const [valorFinal, setValorFinal] = useState(0);

    const obterVinculoAcademia = async () => {
        const academia = await ApiAcademia.listarPorUserId(user.id, token);
        setVinculo(academia.tipo_de_vinculacao);
    };

    const obterEventoDesconto = async (valor) => {
        const response = await ApiEventos.obterEventoDesconto(user.id, evento.id, valor, token);
        console.log(response)
        setValor(response?.valor_original || 0);
        setDesconto(response?.desconto || 0);
        setValorFinal(response?.valor_final || 0);
    };

    useEffect(() => {
        if (user?.id) {
            obterVinculoAcademia();
        }
    }, [user]);

    useEffect(() => {
        if (!evento || !vinculo) return;

        const valorBase =
            vinculo === "Vinculação"
                ? evento.taxaVinculado
                : evento.taxaFiliado;

        setValor(valorBase);
        obterEventoDesconto(valorBase);
    }, [vinculo, evento]);

    return {
        vinculo,
        valor,
        desconto,
        valorFinal
    };
}